import { render, staticRenderFns } from "./room_device_module.vue?vue&type=template&id=4ac85d03&scoped=true"
import script from "./room_device_module.vue?vue&type=script&lang=js"
export * from "./room_device_module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac85d03",
  null
  
)

export default component.exports